<template>
  <div v-if="isOpen" class="modal-default" tabindex="-1" role="dialog" @click.self="closeModal">
    <div class="modal-dialog modal-dialog-centered modal-lg mx-auto" role="document">
      <div class="modal-content border-0 shadow-lg ann-modal">
        <div class="ann-header">
          <div class="ann-header-main">
            <div class="ann-icon">
              <i class="material-icons">star</i>
            </div>
            <div>
              <p class="ann-eyebrow mb-1">Rifa365</p>
              <h4 class="text-white mb-0 font-weight-bolder">
                Afiliado da plataforma
              </h4>
            </div>
          </div>
          <button type="button" class="ann-close" aria-label="Fechar" @click="closeModal">
            <i class="material-icons">close</i>
          </button>
        </div>

        <div class="modal-body ann-body">
          <p class="ann-lead mb-3">
            Indique quem <strong>cria conta no Rifa365</strong>. Quando a pessoa pagar a
            <strong>taxa de publicação</strong> ou ativar o <strong>plano</strong>, você recebe
            <strong>{{ settings.first_fee }}%</strong> dessa 1ª cobrança — no seu saldo de comissões em Meus Indicados.
            Diferente do menu <strong>Seja Afiliado</strong> (afiliado de campanha / rifa).
          </p>

          <div class="ann-notice mb-4">
            <i class="material-icons">trending_up</i>
            <div>
              <strong>Níveis de benefício</strong>
              <p class="mb-0">
                Com 10, 30, 50 ou 100 ativações você desbloqueia % a mais.
                Ex.: 10 pessoas ativando → {{ settings.first_fee }}% + 5% de bônus.
              </p>
            </div>
          </div>

          <div class="ann-notice ann-notice--warn mb-4">
            <i class="material-icons">gavel</i>
            <div>
              <strong>Regras do programa</strong>
              <p class="mb-0">
                Saque mínimo R$ 100 via Pix em Meus Indicados (fora da Carteira
                do Sistema). É proibido autoindicação ou fraude. Condutas
                irregulares são monitoradas: a comissão não é paga e a conta
                pode ser removida do programa e da plataforma pela equipe Rifa365.
              </p>
            </div>
          </div>

          <div class="row g-3 mb-4">
            <div class="col-md-6">
              <div class="ann-feature">
                <div class="ann-feature-icon">
                  <i class="material-icons">link</i>
                </div>
                <div>
                  <h6 class="mb-1 font-weight-bold">Só copiar o link</h6>
                  <p class="mb-0 text-sm">
                    Ative o perfil, copie o link e divulgue no YouTube, Instagram ou WhatsApp.
                    Sem quiz de carteira do sistema.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="ann-feature">
                <div class="ann-feature-icon">
                  <i class="material-icons">payments</i>
                </div>
                <div>
                  <h6 class="mb-1 font-weight-bold">1ª taxa ou plano</h6>
                  <p class="mb-0 text-sm">
                    Comissão única por indicado. Base do plano usada no cálculo:
                    R$ {{ settings.plan_base }}.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-wrap gap-2 justify-content-end">
            <button type="button" class="btn btn-outline-secondary mb-0" @click="closeModal">
              Fechar
            </button>
            <button type="button" class="btn bg-gradient-primary mb-0" @click="closeModal">
              Entendi
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsersHttp from "@/http/UsersHttp.js";

export default {
  name: "AffiliateInfoModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      settings: {
        first_fee: 50,
        plan_base: 97
      }
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.fetchSettings();
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    async fetchSettings() {
      try {
        const response = await UsersHttp.getGlobalSettings();
        if (response.data) {
          const fee = Number(response.data.affiliate_percent_first_fee);
          const plan = Number(response.data.affiliate_plan_fee_base);
          this.settings.first_fee = Number.isFinite(fee) && fee > 0 ? fee : 50;
          this.settings.plan_base = Number.isFinite(plan) && plan > 0 ? plan : 97;
        }
      } catch (error) {
        console.error("Erro ao puxar as taxas:", error);
      }
    }
  }
};
</script>

<style scoped>
.modal-default {
  background-color: rgba(15, 23, 42, 0.45);
  display: flex !important;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  overflow-y: auto;
  padding: 40px 15px;
}

.modal-dialog {
  max-width: 720px;
  width: 100%;
  margin: auto;
}

.ann-modal {
  border-radius: 18px;
  overflow: hidden;
}

.ann-header {
  background: linear-gradient(195deg, #d83184 0%, #f2007b 100%);
  padding: 1.25rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ann-header-main {
  display: flex;
  gap: 0.85rem;
  align-items: center;
}

.ann-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.ann-eyebrow {
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.75);
}

.ann-close {
  border: none;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ann-body {
  padding: 1.5rem;
}

.ann-lead {
  color: #334155;
  font-size: 0.95rem;
}

.ann-notice {
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
  background: #fff5fa;
  border: 1px solid #f8cce3;
  border-radius: 12px;
  padding: 0.9rem 1rem;
}

.ann-notice .material-icons {
  color: #d83184;
}

.ann-notice--warn {
  background: #fff8eb;
  border-color: rgba(184, 144, 60, 0.35);
}

.ann-notice--warn .material-icons {
  color: #8d6b2c;
}

.ann-feature {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  background: #f8fafc;
  border-radius: 12px;
  padding: 0.9rem;
  height: 100%;
}

.ann-feature-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d83184;
  flex-shrink: 0;
}
</style>
